import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../common.ts";
import { Spin } from "antd";

function CustomLinkRedirect() {
  const { code } = useParams();

  useEffect(() => {
    if (!code) return;

    const backendBaseUrl = BASE_URL.replace(/\/$/, "");
    const finalLink = `${backendBaseUrl}/go/${code}`;

    window.location.replace(finalLink);
  }, [code]);

  return (
    <div style={{ textAlign: "center", marginTop: "40px" }}>
      <Spin />
    </div>
  );
}

export default CustomLinkRedirect;
